import { createStyles } from '@mantine/core';

var useStyles = createStyles((theme) => ({
  decadeLevelGroup: {
    display: "flex",
    gap: theme.spacing.md
  }
}));

export default useStyles;
//# sourceMappingURL=DecadeLevelGroup.styles.js.map
